import React from "react";
import {Helmet} from "react-helmet";

export default class SeoComponent extends React.Component {

  seo = {
    title:'',
    meta_title:'',
    meta_keywords:'',
    meta_description:'',
  };
  constructor(prop) {
    super(prop);
    this.seo = prop['seoData'];
  }

  render() {
    return (
        <Helmet>
          <meta charSet="utf-8" />
          <title>{this.seo.meta_title}</title>
          <meta name="keywords" content={this.seo.meta_keywords} />
          <meta name="description" content={this.seo.meta_description} />
        </Helmet>
    );
  }
}
